/* global __BUILD__ */
/* global __BUILDDATE__ */

import Vue from 'vue';
import Vuex from 'vuex';
import Vuelidate from 'vuelidate';
import VueConstants from 'vue-constants';

import validators from './validators';
import { i18n } from './localization';
import hide from '../src/components/common/v-hide/v-hide';
import timeout from '../src/components/directives/timeout';
import ping from '../src/components/directives/ping';

import router from './router';
import store from './store';

import Login from './Login';
import Layout from './Layout';
import Grid from 'ascom-vue-grid';

import './styles/main.scss';

if (__BUILD__) {
    console.log('Running App #' + __BUILD__ + ' built on ', __BUILDDATE__);
}

Vue.use(Vuelidate);
Vue.use(Vuex);
Vue.use(Grid);
Vue.use(VueConstants);

Vue.directive('hide', hide);
Vue.directive('timeout', timeout);
Vue.directive('ping', ping);

// init validators
validators.beforeCreate();

new Vue({
    i18n,
    router,
    store,
    render(h) {
        let { authorized, isLoading } = store.state.user;
        if (isLoading) {
            return null;
        }

        return authorized ? h(Layout) : h(Login);
    },
}).$mount('#app');
